import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';

const hiddenFields = [
  'name',
  'owner',
  'accountSubType',
  'createOnActivation',
  'isCompleted',
  'additionalConsiderationsPlaceholderText',
];

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride(hiddenFields, { hidden: true });
